import React, { Component } from "react";
import Masonry from "../../ui/masonry/masonry";
import InfiniteScroll from "react-infinite-scroller";
import Card from "../../ui/card/card";
import styles from "./grid.css";

class Grid extends Component {
	loadMore() {
		this.props.loadMore();
	}

	render() {
		const { items, hasMore } = this.props;

		return (
			<InfiniteScroll
				pageStart={0}
				loadMore={this.loadMore.bind(this)}
				hasMore={hasMore}
				loader={
					<div className={styles.loading} key={0}>
						Loading…
					</div>
				}
			>
				<Masonry>
					{items.map(info => (
						<Card
							id={info._id}
							title={info.title}
							source={info.source}
							data={info.data}
							image={info.image}
							href={info.url}
							tags={info.tags}
							description={info.description}
							location={info.location}
						/>
					))}
				</Masonry>
			</InfiniteScroll>
		);
	}
}

export default Grid;



// WEBPACK FOOTER //
// ./src/components/ui/grid/grid.js